import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import segnalaMancanti from '../../../components/Util/campiMancanti';
import { usePageTitle } from '../../../layouts/PageHeaderExtra';
import { approvaVideo, rifiutaVideo, statoVideoPresentazione, videoDaApprovare } from '../../../../api-client/appPlayer';
import { LIST_URL } from './index';

/*
 * Scheda di un video di presentazione da approvare: a sinistra il video nuovo, accanto quello che l'app
 * mostra oggi (se c'e`). Approva lo mette nell'app al posto del vecchio; Rifiuta chiede il motivo, che la
 * struttura riceve per email e vede nel Manager. In entrambi i casi la struttura riceve un'email.
 */

export const SchedaVideoPresentazione = () => {
    const { clubId } = useParams();
    const navigate = useNavigate();
    const [voce, setVoce] = useState(null);
    const [stato, setStato] = useState(null);
    const [errore, setErrore] = useState('');
    const [rifiuto, setRifiuto] = useState(false);
    const [motivo, setMotivo] = useState('');
    const [inCorso, setInCorso] = useState(false);

    usePageTitle(voce?.clubName);

    useEffect(() => {
        Promise.all([videoDaApprovare(), statoVideoPresentazione(clubId)]).then(([elenco, s]) => {
            if (elenco?.error || s?.error) { setErrore(elenco?.error || s?.error); setStato({}); return; }
            setVoce(elenco.find((v) => v.clubId === clubId) || null);
            setStato(s);
        });
    }, [clubId]);

    const approva = async () => {
        setInCorso(true);
        const r = await approvaVideo(clubId);
        setInCorso(false);
        if (r?.error) { setErrore(r.error); return; }
        navigate(LIST_URL);
    };

    const rifiuta = async () => {
        if (segnalaMancanti(!motivo.trim() ? [{ campo: 'motivo-rifiuto', messaggio: 'Manca il motivo del rifiuto' }] : []) > 0) return;
        setInCorso(true);
        const r = await rifiutaVideo(clubId, motivo.trim());
        setInCorso(false);
        if (r?.error) { setErrore(r.error); return; }
        setRifiuto(false);
        navigate(LIST_URL);
    };

    if (!stato) return <div className="text-center py-5"><Spinner animation="border" role="status" /></div>;
    const inAttesa = stato.review?.status === 'PENDING' ? stato.review : null;

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <Modal show={rifiuto} onHide={() => setRifiuto(false)} centered>
                <Modal.Header closeButton><Modal.Title>Rifiutare il video?</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form.Label htmlFor="motivo-rifiuto">Motivo (lo riceve la struttura) *</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        id="motivo-rifiuto"
                        maxLength={500}
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-light btn-add" onClick={() => setRifiuto(false)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={rifiuta} disabled={inCorso}>Rifiuta</Button>
                </Modal.Footer>
            </Modal>

            <Card>
                <Card.Body className="sid-card-body--spaced">
                    {!inAttesa && <p>Non c'è più un video da approvare per questa struttura.</p>}
                    <div className="sid-video-verticale__fila">
                        {inAttesa && (
                            <div className="sid-video-verticale">
                                <div className="sid-video-verticale__etichetta">Da approvare</div>
                                <video src={inAttesa.url} controls playsInline preload="metadata" />
                            </div>
                        )}
                        {stato.approved && (
                            <div className="sid-video-verticale">
                                <div className="sid-video-verticale__etichetta">Oggi nell'app</div>
                                <video src={stato.approved.url} controls playsInline preload="metadata" />
                            </div>
                        )}
                    </div>
                    <p className="sid-nota-leggibile mt-3">
                        Controlla che sia verticale, che in alto ci sia il nome del centro sportivo e che le immagini siano adatte.
                    </p>
                </Card.Body>
            </Card>
            <div className="d-flex justify-content-between align-items-center gap-4 mt-4">
                {inAttesa ? <Button className="btn btn-outline-danger" onClick={() => setRifiuto(true)} disabled={inCorso}>Rifiuta</Button> : <span />}
                <div className="d-flex gap-4">
                    {inAttesa && <Button className="btn btn-primary" onClick={approva} disabled={inCorso}>Approva</Button>}
                </div>
            </div>
        </>
    );
};

export default SchedaVideoPresentazione;
